<div [ngClass]="'cc-rich-field'">
  <p-contextMenu #tableContextMng [model]="contextMenuConfig" [hidden]="disabled"
                 appendTo="body"></p-contextMenu>
<!--  appendTo="body"-->
  <span class="d-flex mt-n30 pb-2 pt-5">
    <span class="flex-1"></span>
          <button pButton pRipple icon="pi pi-plus" class="p-button-text p-button-sm p-button-success p-mr-2"
                  (click)="openNew()"
                  [disabled]="disabled"></button>
          <button pButton pRipple icon="pi pi-trash" class="p-button-text p-button-sm p-button-danger"
                  (click)="delete(selectedRecords)"
                  [disabled]="disabled||!selectedRecords || !selectedRecords.length"></button></span>
  <p-table #table styleClass="p-datatable-sm p-datatable-striped"
           [value]="formRecords" [loading]="tableLoading"
           [(contextMenuSelection)]="selectedRecord" [contextMenu]="tableContextMng"
           [dataKey]="formRichFieldConfig.fieldId"
           selectionMode="multiple" [(selection)]="selectedRecords" [metaKeySelection]="true"
           [scrollable]="true"
           [resizableColumns]="true">
    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let columnDef of formRichFieldConfig.tableConfigs"
            [style.width]="columnDef.width ? columnDef.width+'px' : null">
          <div *ngIf="columnDef.field" class="flex justify-content-between align-items-center">
            {{columnDef.label ? columnDef.label : 'page.' + this.transPartKey + '.form.' + columnDef.field | translate}}
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-record let-rowIndex="rowIndex">
      <tr [pSelectableRow]="record" [pContextMenuRow]="record"
          [pSelectableRowIndex]="rowIndex">
        <td *ngFor="let columnDef of formRichFieldConfig.tableConfigs; let i = index" [width]="columnDef.width"
            (dblclick)="edit(record)" (auxclick)="onRowRightClick_(record)">
          <span
            *ngIf="columnDef.field && !columnDef.command && !columnDef.format && !columnDef.mapId"
            [title]="record[columnDef.field]">
            {{record[columnDef.field]}}
          </span>
          <span *ngIf="columnDef.field && (columnDef.type==='DATETIME'||columnDef.type==='DATE')"
                [title]="record[columnDef.field]">
<!--                [title]="record[columnDef.field]  | date:columnDef.format"-->
            <!--            {{record[columnDef.field]  | date:columnDef.format}}-->
            {{record[columnDef.field] }}
          </span>
          <span *ngIf="columnDef.field && (columnDef.type==='NUMERIC')"
                [title]="record[columnDef.field]  | number:columnDef.format ? columnDef.format : '1.0-7'">
            {{record[columnDef.field]  | number:columnDef.format ? columnDef.format : '1.0-7'}}
          </span>
          <span *ngIf="columnDef.field && columnDef.mapId"
                [innerHTML]="fieldValueMap['mapId-inner-' + i + '_' + rowIndex]"
                [title]="fieldValueMap['mapId-' + i + '_' + rowIndex]">
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
<app-cc-form-dialog #ccFormDialog [transPartKey]="transPartKey"
                    [loading]="false" [submitted]="submitted"
                    [(dialogFormVisible)]="dialogFormVisible"
                    [formConfig]="formRichFieldConfig.fields" [dialogFormTitle]="dialogFormTitle"
                    [(formRecord)]="formRecord"
                    (onSubmitEvent)="save()"
                    [disableSubmitButton]="fieldValueMap['validate']"
                    [globalErrorMessage]="fieldValueMap['validate']"
></app-cc-form-dialog>
